import FlexPane from './_flex-pane.js'
import PriceBoostCoupon from './_price-boost-coupon.js'

export default {
  name: 'PriceBoostsView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {},
    },
    priceBoostCoupon: {
      configSet: PriceBoostCoupon,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
